import { Injectable } from '@angular/core';
import {ToastNotifyComponent} from '../shared-components/toast-notify/toast-notify.component';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  private toast!: ToastNotifyComponent;

  register(toast: ToastNotifyComponent) {
    this.toast = toast;
  }

  show(message: string, type: 'success' | 'info' | 'danger' = 'info', duration = 3000) {
    this.toast?.show(message, type, duration);
  }
}
